// Add your JS customizations here
jQuery(document).ready(function($) {

	new WOW().init();

	if ($(window).scrollTop() > 50) {
		$('.navbar').addClass('scrolled');
		$('#search_bar').addClass('scrolled');
		$('#quick_launch').addClass('scrolled');
		$('#member_panel').addClass('scrolled');
		var navHeight = $('.navbar').outerHeight(true);
		$('#services').attr('style','scroll-margin-top:'+navHeight+'px');
	} else {
		$('.navbar').removeClass('scrolled');
		$('#search_bar').removeClass('scrolled');
		$('#quick_launch').removeClass('scrolled');
		$('#member_panel').removeClass('scrolled');
	}

	$(window).on('scroll', function() {
		if ($(window).scrollTop() > 50) {
			$('.navbar').addClass('scrolled');
			$('#search_bar').addClass('scrolled');
			$('#quick_launch').addClass('scrolled');
			$('#member_panel').addClass('scrolled');
			var navHeight = $('.navbar').outerHeight(true);
			$('#services').attr('style','scroll-margin-top:'+navHeight+'px');
		} else {
			$('.navbar').removeClass('scrolled');
			$('#search_bar').removeClass('scrolled');
			$('#quick_launch').removeClass('scrolled');
			$('#member_panel').removeClass('scrolled');
		}
	});

	$('body').addClass('active');

	$('.hamburger').click(function(event) {
		event.preventDefault();
		$('#denham_menu').removeClass('sales_active');
		$('#denham_menu').removeClass('lettings_active');
		$('#denham_menu').removeClass('about_active');
		$('.sub_menus .list-unstyled').removeClass('active');
		$('#desktop_menu_links .has_sub').removeClass('active');
		$('.sub_menus .card').removeClass('active');
		$('.sub_menus').removeClass('mshow');
		$('.primary_menu').removeClass('mhide');
		$('body').toggleClass('menu_open');
		$(this).toggleClass('is-active');
		$('#denham_menu').toggleClass('active');
	});

	$('#desktop_menu_links .has_sub').click(function(event) {
		event.preventDefault();
		var $menu = $(this).data('menu');
		var $original = $('#denham_menu').data('original');
		var $target = $(this).attr('href');
		if ($(window).width() > 992) {
			if($(this).hasClass('active')) {
				$('#denham_menu').removeClass($menu);
				$(this).removeClass('active');
				$($target).removeClass('active');
			} else {
				$('.sub_menus .list-unstyled').removeClass('active');
				$('#desktop_menu_links .has_sub').removeClass('active');
				$('#denham_menu').removeClass('sales_active');
				$('#denham_menu').removeClass('lettings_active');
				$('#denham_menu').removeClass('about_active');
				$('#lettings_menu').removeClass('active');
				$('#sales_menu').removeClass('active');
				$('#about_menu').removeClass('active');
				$(this).addClass('active');
				$('#denham_menu').addClass($menu);
				setTimeout(function () {
					$($target).addClass('active');
				}, 300);
			}
		} else {
			$('.primary_menu').addClass('mhide');
			$('.sub_menus').addClass('mshow');
			$('#denham_menu').addClass($menu);
			setTimeout(function () {
				$($target).addClass('active');
			}, 300);
		}
	});

	$('.close_sub').click(function(event) {
		event.preventDefault();
		$('.sub_menus .card').removeClass('active');
		$('.sub_menus').removeClass('mshow');
		$('.primary_menu').removeClass('mhide');
		$('#denham_menu').removeClass('sales_active');
		$('#denham_menu').removeClass('lettings_active');
		$('#denham_menu').removeClass('about_active');
	});

	$('#quick_launch a').click(function(event) {
		event.preventDefault();
		if($(this).hasClass('active')) {
			$('#quick_contact').removeClass('active');
			$('#quick_bg').removeClass('active');
			$(this).removeClass('active');
			$('body').removeClass('menu_open');
		} else {
			$('#quick_bg').addClass('active');
			setTimeout(function () {
				$('#quick_contact').addClass('active');
			}, 750);
			$('body').addClass('menu_open');
			$(this).addClass('active');
			$('#quick_contact').scrollTop(0);
		}
	});

	$('#input_1_7').select2({
		placeholder: 'Interest',
		width: '100%',
		minimumResultsForSearch: Infinity,
	});

	if ($('.page-template-contact').length > 0) {
		$('#contact_form_container').matchHeight({
			target: $('#contact_form_container .card-img-overlay'),
		});
	};

	if ($('.single-property').length > 0) {
		if ($(window).width() < 992) {
			$('#actions_collapse').removeClass('show');
		}
		$('#details_slider').slick({
			fade: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			prevArrow: '.details_prev',
			nextArrow: '.details_next',
			asNavFor: '#thumbs_slider',
			autoplay: true,
			autoplaySpeed: 4000,
			speed: 1500,
			infinite: true,
		});
		$('#thumbs_slider').slick({
			fade: false,
			slidesToShow: 6,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			focusOnSelect: true,
			asNavFor: '#details_slider',
			autoplay: true,
			autoplaySpeed: 4000,
			speed: 1500,
			infinite: true,
			responsive: [
			    {
			      	breakpoint: 769,
			      	settings: {
			      		slidesToShow: 3,
			      		infinite: true,
			      	}	
			    },
			],
		});
		$('.property-enquiry-form .control-name input').attr('placeholder','Name');
		$('.property-enquiry-form .control-email_address input').attr('placeholder','Email Address');
		$('.property-enquiry-form .control-telephone_number input').attr('placeholder','Phone Number');
		$('.property-enquiry-form .control-message textarea').attr('placeholder','Message');
	};

	if ($('.post-type-archive-property').length > 0) {
		if ($(window).width() < 992) {
			$('#filterHeading h5').attr('aria-expanded',false);
			$('#filter__xs').removeClass('show');
		}

		$('.property-search-form #property_type').select2({
			placeholder: 'Property Type',
			width: '100%',
			minimumResultsForSearch: Infinity,
		});
		$('.property-search-form #minimum_price').select2({
			placeholder: 'Min Price',
			width: '100%',
			minimumResultsForSearch: Infinity,
		});
		$('.property-search-form #minimum_rent').select2({
			placeholder: 'Min Rent',
			width: '100%',
			minimumResultsForSearch: Infinity,
		});
		$('.property-search-form #minimum_bedrooms').select2({
			placeholder: 'Min Beds',
			width: '100%',
			minimumResultsForSearch: Infinity,
		});
		$('.property-search-form #maximum_price').select2({
			placeholder: 'Max Price',
			width: '100%',
			minimumResultsForSearch: Infinity,
		});
		$('.property-search-form #maximum_rent').select2({
			placeholder: 'Max Rent',
			width: '100%',
			minimumResultsForSearch: Infinity,
		});
		$('.property-search-form #maximum_bedrooms').select2({
			placeholder: 'Max Beds',
			width: '100%',
			minimumResultsForSearch: Infinity,
		});
		$('.property-search-form #radius').select2({
			placeholder: 'Radius',
			width: '100%',
			minimumResultsForSearch: Infinity,
		});
		$('.property-search-form #department').select2({
			width: '100%',
			minimumResultsForSearch: Infinity,
		});
		$('.propertyhive-ordering .orderby').select2({
			width: '80%',
			minimumResultsForSearch: Infinity,
		});
	}

	if ($('.page-template-home').length > 0) {

		$('#header_carousel').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		    var i = (currentSlide ? currentSlide : 0) + 1;
		    var slidesToShow = slick.slickGetOption('slidesToShow');
		    var curPage = parseInt((i-1)/slidesToShow) + 1;
		    $('.h_count').html(curPage);
		});

		$('#header_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			autoplay: true,
			autoplaySpeed: 3000,
			speed: 1000,
			fade: true,
			prevArrow: $('#header_controls .prev_slide'),
			nextArrow: $('#header_controls .next_slide'),
			
		});

		$('#header_carousel').on('slide.bs.carousel', function (event) {
			var slide = $(event.relatedTarget).data('count');
			$('#header_controls .h_count').html(slide);
		});		

	};

	$('#forsale_carousel').on('init', function(event, slick){
		$.fn.matchHeight._update();
	});

	$('#forsale_carousel').slick({
		slidesToShow: 1.9,
		slidesToScroll: 1,
		infinite: false,
		arrows: true,
		dots: false,
		autoplay: false,
		speed: 1000,
		fade: false,
		prevArrow: $('.forsale_slide_controls .prev_slide'),
		nextArrow: $('.forsale_slide_controls .next_slide'),
		responsive: [
		    {
		      	breakpoint: 769,
		      	settings: {
		      		slidesToShow: 1,
		      		fade: true,
		      		infinite: true,
		      	}	
		    },
		],
	});

	$('#lettings_carousel').on('init', function(event, slick){
		$.fn.matchHeight._update();
	});


	$('#lettings_carousel').slick({
		slidesToShow: 1.9,
		slidesToScroll: 1,
		infinite: false,
		arrows: true,
		dots: false,
		autoplay: false,
		speed: 1000,
		fade: false,
		prevArrow: $('.lettings_slide_controls .prev_slide'),
		nextArrow: $('.lettings_slide_controls .next_slide'),
		responsive: [
		    {
		      	breakpoint: 769,
		      	settings: {
		      		slidesToShow: 1,
		      		fade: true,
		      		infinite: true,
		      	}	
		    },
		],
	});

	$('#team_carousel').slick({
		slidesToShow: 2.5,
		slidesToScroll: 1,
		infinite: false,
		arrows: true,
		dots: false,
		autoplay: false,
		speed: 1000,
		fade: false,
		prevArrow: $('.team_carousel_controls .prev_slide'),
		nextArrow: $('.team_carousel_controls .next_slide'),
		responsive: [
		    {
		      	breakpoint: 769,
		      	settings: {
		      		slidesToShow: 1,
		      		fade: true,
		      		infinite: true,
		      	}	
		    },
		],
	});

	
	$('#forsale_tab').click(function() {
		if($('.forsale_slide_controls').hasClass('d-none')) {
			$('.forsale_slide_controls').removeClass('d-none');
			$('.lettings_slide_controls').addClass('d-none');
		} else {
			
		}
		$('#forsale_carousel').slick('setPosition');
		$.fn.matchHeight._update();
	});

	$('#lettings_tab').click(function() {
		if($('.lettings_slide_controls').hasClass('d-none')) {
			$('.lettings_slide_controls').removeClass('d-none');
			$('.forsale_slide_controls').addClass('d-none');
		} else {
			
		}
		$('#lettings_carousel').slick('setPosition');
		$.fn.matchHeight._update();
	});

	$('#services_carousel').slick({
		slidesToShow: 1.05,
		slidesToScroll: 1,
		infinite: false,
		arrows: true,
		dots: false,
		autoplay: false,
		speed: 1000,
		prevArrow: $('#services_carousel_controls .prev_slide'),
		nextArrow: $('#services_carousel_controls .next_slide'),
	}).on('setPosition', function (event, slick) {
      	slick.$slides.css('height', slick.$slideTrack.height() + 'px');
 	});

	$('#testimonials_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 1000,
		fade: true,
		prevArrow: $('#testimonials_controls .prev_slide'),
		nextArrow: $('#testimonials_controls .next_slide'),
	});

	const para1 = document.getElementsByClassName('para1');
	const para2 = document.getElementsByClassName('para2');
	if ($(window).width() > 992) {
		new simpleParallax(para1, {
			//delay: .25,
			orientation: 'up',
			scale: 1.15,
			overflow: false,
			//transition: 'cubic-bezier(0,0,0,1)',
		});
		new simpleParallax(para2, {
			//delay: .25,
			orientation: 'up',
			scale: 3,
			overflow: true,
			transition: 'cubic-bezier(0,0,0,1)',
		});
	};

	$('#services .service').on('click', function() {
		var navHeight = $('.navbar').outerHeight(true);
		$('html,body').animate({
        	scrollTop: $("#services").offset().top - navHeight},
        'fast');
		var order = $(this).data('order');
		if($(this).hasClass('inactive')) {
			if((order) == 1) {
				$('#services .service[data-order="2"]').removeClass('service_left').addClass('service_right');
				$('#services .service[data-order="3"]').removeClass('service_left').addClass('service_right');
			}
			if((order) == 2) {
				$('#services .service[data-order="3"]').removeClass('service_left').addClass('service_right');
			}
			if((order) == 3) {
				$('#services .service[data-order="2"]').removeClass('service_right').addClass('service_left');
			}
			$('#services .service .service_content_details').fadeOut();
			$('#services .service.active').removeClass('active').addClass('inactive');
			$('#services .service .service_content').removeClass('active').addClass('inactive');
			$('#services .service .service_content_details').removeClass('active').addClass('inactive');

			$(this).removeClass('inactive').addClass('active');
			setTimeout(function () {
				$('#services .service.active .service_content').removeClass('inactive').addClass('active');
			}, 1600);
			setTimeout(function () {
				$('#services .service.active .service_content_details').fadeIn();
			}, 750);
		}
	});

	$('#services_controls .prev_slide').click(function(event) {
		event.preventDefault();
		var navHeight = $('.navbar').outerHeight(true);
		$('html,body').animate({
        	scrollTop: $("#services").offset().top - navHeight},
        'fast');
		
		var currentSlide = $('#services .service.active').data('order');
		if(currentSlide == 1) {
			var prevSlide = 3;
		} else {
			var prevSlide = currentSlide - 1;
		}
		$('#services .service .service_content_details').fadeOut();
		$('#services .service.active').removeClass('active').addClass('inactive');
		$('#services .service .service_content').removeClass('active').addClass('inactive');
		
		if((prevSlide) == 1) {
			$('#services .service[data-order="2"]').removeClass('service_left').addClass('service_right');
			$('#services .service[data-order="3"]').removeClass('service_left').addClass('service_right');
		}
		if((prevSlide) == 2) {
			$('#services .service[data-order="3"]').removeClass('service_left').addClass('service_right');
		}
		if((prevSlide) == 3) {
			$('#services .service[data-order="2"]').removeClass('service_right').addClass('service_left');
		}
		
		$('#services .service[data-order="' + prevSlide +'"]').removeClass('inactive').addClass('active');
		setTimeout(function () {
			$('#services .service.active .service_content').removeClass('inactive').addClass('active');
		}, 1600);
		setTimeout(function () {
			$('#services .service.active .service_content_details').fadeIn();
		}, 750);
	});

	$('#services_controls .next_slide').click(function(event) {
		event.preventDefault();
		var navHeight = $('.navbar').outerHeight(true);
		$('html,body').animate({
        	scrollTop: $("#services").offset().top - navHeight},
        'fast');
		var currentSlide = $('#services .service.active').data('order');
		//console.log(currentSlide);
		if(currentSlide == 3) {
			var nextSlide = 1;
		} else {
			var nextSlide = currentSlide + 1;

		}
		//console.log(nextSlide);
		$('#services .service .service_content_details').fadeOut();
		$('#services .service.active').removeClass('active').addClass('inactive');
		$('#services .service .service_content').removeClass('active').addClass('inactive');
		
		if((nextSlide) == 1) {
			$('#services .service[data-order="2"]').removeClass('service_left').addClass('service_right');
			$('#services .service[data-order="3"]').removeClass('service_left').addClass('service_right');
		}
		if((nextSlide) == 2) {
			$('#services .service[data-order="3"]').removeClass('service_left').addClass('service_right');
		}
		if((nextSlide) == 3) {
			$('#services .service[data-order="2"]').removeClass('service_right').addClass('service_left');
		}

		$('#services .service[data-order="' + nextSlide +'"]').removeClass('inactive').addClass('active');
		setTimeout(function () {
			$('#services .service.active .service_content').removeClass('inactive').addClass('active');
		}, 1600);
		setTimeout(function () {
			$('#services .service.active .service_content_details').fadeIn();
		}, 750);
		//console.log(nextSlide);
	});

	$('a[href="#services_expanded"]').click(function() {
		$(this).text($(this).text() == 'Load more' ? 'Show less' : 'Load more');
	});

});
